import {
  GET_ACCOUNT_DATA,
  GET_ACCOUNT_LINES,
  GET_TYPES,
  GET_TROUBLE_TICKET_HISTORY,
  GET_ACCOUNT_INVOICES,
  GET_BILLS_DETAILS,
  GET_ORDERS,
  GET_BARRING_SERVICES 
} from './actionsTypes'

const initialState = {
  accountData: {},
  accountLines: {},
  troubleTicketFaultTypes: {},
  troubleTicketHistory: {},
  accountInvoices: {},
  billsDetails: {},
  orders:{},
  barringServices:{}
}

const paltelCorporateData = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ACCOUNT_DATA:
      return {
        ...state,
        accountData: payload,
      }
    case GET_ACCOUNT_LINES:
      return {
        ...state,
        accountLines: payload,
      }
    case GET_TYPES:
      return {
        ...state,
        troubleTicketFaultTypes: payload,
      }
    case GET_TROUBLE_TICKET_HISTORY:
      return {
        ...state,
        troubleTicketHistory: payload,
      }
    case GET_ACCOUNT_INVOICES:
      return {
        ...state,
        accountInvoices: payload,
      }
    case GET_BILLS_DETAILS:
      return {
        ...state,
        billsDetails: payload,
      }
      case GET_ORDERS:
        return {
          ...state,
          orders: payload,
        }
      case GET_BARRING_SERVICES :
        return {
          ...state,
          barringServices: payload,
        }
    default:
      return state
  }
}

export default paltelCorporateData
